import { useTranslation } from 'react-i18next';
export const LOCALES = [
  { code: 'fr-FR', label: 'Français (FR)' },
  { code: 'en-GB', label: 'English (UK)' },
  { code: 'en-US', label: 'English (US)' },
  { code: 'es-ES', label: 'Español (ES)' },
  { code: 'it-IT', label: 'Italiano (IT)' },
  { code: 'de-DE', label: 'Deutsch (DE)' },
  { code: 'zh-CN', label: '中文 (简体)' },
];
export const DEFAULT_LOCALE = 'en-US';
